<template>
    <!-- <div class="row mb-4">
        <div class="col-md-6">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
    </div> -->

    <datatable :url="ajaxUrl" :limit="limit">
        <template #headings>
            <th>Amount</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="allocation in data" :key="allocation.id">
                <td>{{ allocation.amount }}</td>
                <td v-html="allocation.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import { ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
});

const limit = ref(25);
</script>
